import get from 'lodash/get'

export const getCertificates = state => get(state, 'certificates')
